export const isProduction = process.env.REACT_APP_BUILD_TYPE === "production";
export const isDevelopment = process.env.NODE_ENV === "development";

type customWindow = typeof window & {
  env: {
    BASE_URL: string;
    REACT_APP_MAPS_API_KEY: string;
    REACT_APP_ENV: string;
    REACT_APP_VERSION: string;
  };
};

export const BASE_URL = (window as customWindow).env.BASE_URL;
export const REACT_APP_MAPS_API_KEY = (window as customWindow).env.REACT_APP_MAPS_API_KEY;
export const REACT_APP_ENV =
  (window as customWindow).env.REACT_APP_ENV?.toLowerCase() || "development";
export const REACT_APP_VERSION = (window as customWindow).env.REACT_APP_VERSION;

export const HOST = isDevelopment ? "https://sys-portal.principle-connect.com" : undefined;

// The api urls, not the site urls (.api)
export const DMS_PORTAL_URLS = [
  "https://dms-api.principle-connect.com",
  "https://sys-dms-api.principle-connect.com",
  "https://uat-dms-api.principle-connect.com",
];

export const endpoints = {
  auth: {
    login: "/api/v1/publicrole/authmodule/login",
    mfaChallenge: "/api/v1/publicrole/authmodule/mfa/challenge",
    mfaLogin: "/api/v1/publicrole/authmodule/mfa/login",
    refreshAccessToken: "/api/v1/publicrole/authmodule/refresh",
    logout: "/api/v1/publicrole/authmodule/logout",
    requestpasswordreset: "/api/v1/publicrole/forgottenpasswordmodule/requestpasswordreset",
    resetpassword: "/api/v1/publicrole/forgottenpasswordmodule/resetpassword",
    entra: {
      authorize: "/api/v1/publicrole/authmodule/entra/authorize",
      session: "/api/v1/publicrole/authmodule/entra/session",
      tenants: "/api/v1/publicrole/authmodule/entra/tenants",
    },
  },
  profilePhoto: {
    photo: "/api/v1/platformuserrole/profilephotomodule/photo",
    contactPhoto: "/api/v1/platformuserrole/profilephotomodule/contact-photo",
  },
  registration: {
    create: "/api/v1/publicrole/registrationmodule/create",
  },
  accountVerification: {
    requirements: "/api/v1/publicrole/accountverificationmodule/requirements",
    verifyEmail: "/api/v1/publicrole/accountverificationmodule/emailaddress/verify",
    verifyPhoneNumber: "/api/v1/publicrole/accountverificationmodule/mobilephone/verify",
    setPassword: "/api/v1/publicrole/accountverificationmodule/password/set",
    resendLink: "/api/v1/publicrole/accountverificationmodule/resendlink",
    mfaChallenge: "/api/v1/publicrole/accountverificationmodule/mfa/challenge",
    mfaEnable: "/api/v1/publicrole/accountverificationmodule/mfa/enable",
    requestTotpQrCode: "/api/v1/publicrole/accountverificationmodule/mfa/requesttotpqrcode",
    mobilePhoneRequestCode: "/api/v1/publicrole/accountverificationmodule/mobilephone/requestcode",
    mobilePhoneSubmitCode: "/api/v1/publicrole/accountverificationmodule/mobilephone/verify",
    resendLinkByUserName: "/api/v1/publicrole/accountverificationmodule/resendlinkbyusername",
  },
  platformUsers: {
    listCSV: "/api/v1/platformuserrole/platformusersmodule/list-csv",
    listUsers: "/api/v1/platformuserrole/platformusersmodule/list",
    viewUser: "/api/v1/platformuserrole/platformusersmodule/view",
    createUser: "/api/v1/platformuserrole/platformusersmodule/create",
    editUser: "/api/v1/platformuserrole/platformusersmodule/edit",
    deleteUsers: "/api/v1/platformuserrole/platformusersmodule/delete",
    resendVerificationLink: "/api/v1/platformuserrole/platformusersmodule/resendverificationlink",
    createBulk: "/api/v1/platformuserrole/platformusersmodule/users-upload",
    search: {
      platformCompanies: "/api/v1/platformuserrole/companiesmodule/search-platform-companies",
    },
  },
  principleUsers: {
    listCSV: "/api/v1/platformuserrole/principleusersmodule/list-csv",
    list: "/api/v1/platformuserrole/principleusersmodule/list",
    view: "/api/v1/platformuserrole/principleusersmodule/view",
    create: "/api/v1/platformuserrole/principleusersmodule/create",
    edit: "/api/v1/platformuserrole/principleusersmodule/edit",
    delete: "/api/v1/platformuserrole/principleusersmodule/delete",
    resendVerificationLink: "/api/v1/platformuserrole/principleusersmodule/resendverificationlink",
    createBulk: "/api/v1/platformuserrole/principleusersmodule/users-upload",
  },
  staticContent: {
    list: "/api/v1/adminrole/webpagespartsmodule/list",
    create: "/api/v1/adminrole/webpagespartsmodule/create",
    edit: "/api/v1/adminrole/webpagespartsmodule/edit",
    view: "/api/v1/adminrole/webpagespartsmodule/view",
    delete: "/api/v1/adminrole/webpagespartsmodule/delete",
  },
  ckFinderModule: {
    uploadImage: "/api/v1/adminrole/ckfindermodule/uploadimage",
  },
  profile: {
    details: "/api/v1/platformuserrole/profilemodule/details",
    updatePassword: "/api/v1/platformuserrole/profilemodule/updatepassword",
    changePassword: "/api/v1/platformuserrole/profilemodule/changepassword",
    deleteAccount: "/api/v1/platformuserrole/profilemodule/deleteaccount",
    mfaChallenge: "/api/v1/platformuserrole/profilemodule/mfa/challenge",
    updateEmailAddressRequest: "/api/v1/platformuserrole/profilemodule/emailaddress/requestupdate",
    updateEmailAddressConfirm: "/api/v1/platformuserrole/profilemodule/emailaddress/confirmupdate",
    updatePhoneNumberRequest: "/api/v1/platformuserrole/profilemodule/mobilephone/requestupdate",
    updatePhoneNumberConfirm: "/api/v1/platformuserrole/profilemodule/mobilephone/confirmupdate",
    getBrandSettings: "/api/v1/platformuserrole/profilemodule/brandsettings",
  },
  adminprofile: {
    details: "/api/v1/adminrole/profilemodule/details",
    updatePassword: "/api/v1/adminrole/profilemodule/updatepassword",
    changePassword: "/api/v1/adminrole/profilemodule/changepassword",
    deleteAccount: "/api/v1/adminrole/profilemodule/deleteaccount",
    mfaChallenge: "/api/v1/adminrole/profilemodule/mfa/challenge",
    updateEmailAddressRequest: "/api/v1/adminrole/profilemodule/emailaddress/requestupdate",
    updateEmailAddressConfirm: "/api/v1/adminrole/profilemodule/emailaddress/confirmupdate",
    updatePhoneNumberRequest: "/api/v1/adminrole/profilemodule/mobilephone/requestupdate",
    updatePhoneNumberConfirm: "/api/v1/adminrole/profilemodule/mobilephone/confirmupdate",
    getBrandSettings: "/api/v1/platformuserrole/profilemodule/brandsettings",
  },
  settings: {
    enableChallengeType: "/api/v1/adminrole/profilemodule/mfa/enablechallengetype",
    disableChallengeType: "/api/v1/adminrole/profilemodule/mfa/disablechallengetype",
    requestTotpQrCode: "/api/v1/adminrole/profilemodule/mfa/requesttotpqrcode",
    challenge: "/api/v1/adminrole/profilemodule/mfa/challenge",
  },
  assets: {
    listAssets: "/api/v1/platformuserrole/assetsmodule/list",
    listCSV: "/api/v1/platformuserrole/assetsmodule/list-csv",
    cardList: "/api/v1/platformuserrole/assetsmodule/card-list",
    deleteAssets: "/api/v1/platformuserrole/assetsmodule/delete",
    viewAssets: "/api/v1/platformuserrole/assetsmodule/view",
    createAssets: "/api/v1/platformuserrole/assetsmodule/create",
    createBulk: "/api/v1/platformuserrole/assetsmodule/assets-upload",
    updateAssetStatus: "/api/v1/platformuserrole/assetsmodule/statuses-update",
    snaggAssets: "/api/v1/platformuserrole/assetsmodule/snagging-update",
    datesAssets: "/api/v1/platformuserrole/assetsmodule/dates-update",
    editAssets: "/api/v1/platformuserrole/assetsmodule/edit",
    catalogueItemDetails: "/api/v1/platformuserrole/assetsmodule/catalogueitemdetails",
    search: {
      projects: "/api/v1/platformuserrole/assetsmodule/create-projects-search",
      catalogueItems: "/api/v1/platformuserrole/assetsmodule/create-catalogue-items-search",
      assetStatusType: "/api/v1/platformuserrole/assetsmodule/create-asset-type-search",
      assetGroupSearch: "/api/v1/platformuserrole/assetsmodule/create-asset-group-search",
      supplierCompany: "/api/v1/platformuserrole/assetsmodule/create-supplier-company-search",
    },
  },
  snagging: {
    create: "/api/v1/platformuserrole/snaggingmodule/create",
    delete: "/api/v1/platformuserrole/snaggingmodule/delete",
    edit: "/api/v1/platformuserrole/snaggingmodule/edit",
    list: "/api/v1/platformuserrole/snaggingmodule/list",
    listCsv: "/api/v1/platformuserrole/snaggingmodule/list-csv",
    view: "/api/v1/platformuserrole/snaggingmodule/view",
    search: {
      assets: "/api/v1/platformuserrole/assetsmodule/search-project-assets",
      categories: "/api/v1/platformuserrole/snaggingcategoriesmodule/search",
      projectContacts: "/api/v1/platformuserrole/contactsmodule/search-project-contacts",
      reasonCodes: "/api/v1/platformuserrole/reasoncodesmodule/search-snagging",
      suppliers: "/api/v1/platformuserrole/companiesmodule/search-suppliers",
    },
  },
  snaggingCategories: {
    create: "/api/v1/platformuserrole/snaggingcategoriesmodule/create",
    delete: "/api/v1/platformuserrole/snaggingcategoriesmodule/delete",
    edit: "/api/v1/platformuserrole/snaggingcategoriesmodule/edit",
    list: "/api/v1/platformuserrole/snaggingcategoriesmodule/list",
  },
  userPools: {
    list: "/api/v1/platformuserrole/userPoolsmodule/list",
    listCSV: "/api/v1/platformuserrole/userPoolsmodule/list-csv",
    create: "/api/v1/platformuserrole/userPoolsmodule/create",
    edit: "/api/v1/platformuserrole/userPoolsmodule/edit",
    view: "/api/v1/platformuserrole/userPoolsmodule/view",
    delete: "/api/v1/platformuserrole/userPoolsmodule/delete",
    search: {
      users: "/api/v1/platformuserrole/userPoolsmodule/create-users-search",
    },
  },
  holidays: {
    list: "/api/v1/platformuserrole/Holidaysmodule/list",
    create: "/api/v1/platformuserrole/Holidaysmodule/create",
    view: "/api/v1/platformuserrole/Holidaysmodule/view",
    edit: "/api/v1/platformuserrole/Holidaysmodule/edit",
    delete: "/api/v1/platformuserrole/Holidaysmodule/delete",
  },
  companies: {
    listCompanies: "/api/v1/platformuserrole/companiesmodule/list",
    listCSV: "/api/v1/platformuserrole/companiesmodule/list-csv",
    viewCompany: "/api/v1/platformuserrole/companiesmodule/view",
    createCompany: "/api/v1/platformuserrole/companiesmodule/create",
    editCompany: "/api/v1/platformuserrole/companiesmodule/edit",
    deleteCompanies: "/api/v1/platformuserrole/companiesmodule/delete",
  },
  clientCompanies: {
    list: "/api/v1/platformuserrole/ClientCompaniesmodule/list",
    listCSV: "/api/v1/platformuserrole/ClientCompaniesmodule/list-csv",
    view: "/api/v1/platformuserrole/ClientCompaniesmodule/view",
    create: "/api/v1/platformuserrole/ClientCompaniesmodule/create",
    edit: "/api/v1/platformuserrole/ClientCompaniesmodule/edit",
    delete: "/api/v1/platformuserrole/ClientCompaniesmodule/delete",
  },
  currencies: {
    listCurrencies: "/api/v1/platformuserrole/currenciesmodule/list",
    createCurrencies: "/api/v1/platformuserrole/currenciesmodule/create",
    editCurrencies: "/api/v1/platformuserrole/currenciesmodule/edit",
    viewCurrencies: "/api/v1/platformuserrole/currenciesmodule/view",
    deleteCurrencies: "/api/v1/platformuserrole/currenciesmodule/delete",
  },
  invoiceCategoryTypes: {
    list: "/api/v1/platformuserrole/invoicecategorytypesmodule/list",
    create: "/api/v1/platformuserrole/invoicecategorytypesmodule/create",
    edit: "/api/v1/platformuserrole/invoicecategorytypesmodule/edit",
    view: "/api/v1/platformuserrole/invoicecategorytypesmodule/view",
    delete: "/api/v1/platformuserrole/invoicecategorytypesmodule/delete",
  },
  paymentOptionTypes: {
    list: "/api/v1/platformuserrole/paymentoptiontypesmodule/list",
    create: "/api/v1/platformuserrole/paymentoptiontypesmodule/create",
    edit: "/api/v1/platformuserrole/paymentoptiontypesmodule/edit",
    view: "/api/v1/platformuserrole/paymentoptiontypesmodule/view",
    delete: "/api/v1/platformuserrole/paymentoptiontypesmodule/delete",
  },
  exchangeRates: {
    list: "/api/v1/platformuserrole/exchangeratesmodule/list",
    create: "/api/v1/platformuserrole/exchangeratesmodule/create",
    edit: "/api/v1/platformuserrole/exchangeratesmodule/edit",
    view: "/api/v1/platformuserrole/exchangeratesmodule/view",
    delete: "/api/v1/platformuserrole/exchangeratesmodule/delete",
  },
  reasonCodes: {
    list: "/api/v1/platformuserrole/reasoncodesmodule/list",
    create: "/api/v1/platformuserrole/reasoncodesmodule/create",
    edit: "/api/v1/platformuserrole/reasoncodesmodule/edit",
    view: "/api/v1/platformuserrole/reasoncodesmodule/view",
    delete: "/api/v1/platformuserrole/reasoncodesmodule/delete",
  },
  sites: {
    listSites: "/api/v1/platformuserrole/sitesmodule/list",
    listColumns: "/api/v1/platformuserrole/sitesmodule/list-columns",
    listRowData: "/api/v1/platformuserrole/sitesmodule/list-rowdata",
    listCSV: "/api/v1/platformuserrole/sitesmodule/list-csv",
    filterData: "/api/v1/platformuserrole/sitesmodule/list-filter-data",
    viewSites: "/api/v1/platformuserrole/sitesmodule/view",
    createSites: "/api/v1/platformuserrole/sitesmodule/create",
    createSitesBulk: "/api/v1/platformuserrole/sitesmodule/sites-upload",
    editSites: "/api/v1/platformuserrole/sitesmodule/edit",
    deleteSites: "/api/v1/platformuserrole/sitesmodule/delete",
    getMapCoordinates:
      "https://stoplight.io/mocks/avamae/principle-cloud-web-user-v1/204548593/sitesmodule/getMapCoordinates",
    history: "/api/v1/platformuserrole/sitesmodule/changelog-list",
    search: {
      clients: undefined,
      assets: "/api/v1/platformuserrole/sitesmodule/create-assets-search",
      contacts: "/api/v1/platformuserrole/sitesmodule/create-contacts-search",
      projects: "/api/v1/platformuserrole/sitesmodule/create-projects-search",
      surveys: "/api/v1/platformuserrole/sitesmodule/create-surveys-search",
      siteTypes: "/api/v1/platformuserrole/sitesmodule/create-site-types-search",
      siteStatus: "/api/v1/platformuserrole/sitesmodule/create-site-status-search",
    },
    deleteIncompleteItems: "/api/v1/platformuserrole/sitesmodule/cancel-create-edit",
  },
  projects: {
    listProjects: "/api/v1/platformuserrole/projectsmodule/list",
    listCSV: "/api/v1/platformuserrole/projectsmodule/list-csv",
    viewProjects: "/api/v1/platformuserrole/projectsmodule/view",
    createProjects: "/api/v1/platformuserrole/projectsmodule/create",
    editProjects: `/api/v1/platformuserrole/projectsmodule/edit`,
    deleteProjects: "/api/v1/platformuserrole/projectsmodule/delete",
    programmes: "/api/v1/platformuserrole/projectsmodule/programmes",
    getProjectManagement:
      "https://stoplight.io/mocks/avamae/principle-cloud-web-user-v1/204548593/projectsmodule/projectManagement",
    search: {
      sites: "/api/v1/platformuserrole/projectsmodule/create-sites-search",
      clientCompany: "/api/v1/platformuserrole/projectsmodule/create-client-company-search",
      client: "/api/v1/platformuserrole/projectsmodule/create-client-company-search",
      parentProgramme: "/api/v1/platformuserrole/projectsmodule/create-parent-programme-search",
      supplierCompany: "/api/v1/platformuserrole/projectsmodule/create-supplier-company-search",
      employeesSearch: "/api/v1/platformuserrole/projectsmodule/create-employees-search",
      documents: "/api/v1/platformuserrole/projectsmodule/create-documents-search",
      workflows: "/api/v1/platformuserrole/projectsmodule/create-workflows-search",
      assets: "/api/v1/platformuserrole/projectsmodule/create-assets-search",
    },
  },
  roles: {
    list: `/api/v1/platformuserrole/rolesmodule/list`,
    listCSV: "/api/v1/platformuserrole/rolesmodule/list-csv",
    view: `/api/v1/platformuserrole/rolesmodule/view`,
    edit: `/api/v1/platformuserrole/rolesmodule/edit`,
    editDms: `/api/v1/platformuserrole/rolesmodule/edit-dms`,
    create: `/api/v1/platformuserrole/rolesmodule/create`,
    createDms: `/api/v1/platformuserrole/rolesmodule/create-dms`,
    editDocumentAccess: "/api/v1/platformuserrole/rolesmodule/edit-document-access",

    editCommunicationAccess: "/api/v1/platformuserrole/rolesmodule/edit-communication-access",
    delete: `/api/v1/platformuserrole/rolesmodule/delete`,
    search: {
      users: "/api/v1/platformuserrole/rolesmodule/create-associated-users-search",
    },
  },
  contacts: {
    list: `/api/v1/platformuserrole/contactsmodule/list`,
    listCSV: "/api/v1/platformuserrole/contactsmodule/list-csv",
    view: `/api/v1/platformuserrole/contactsmodule/view`,
    edit: `/api/v1/platformuserrole/contactsmodule/edit`,
    create: `/api/v1/platformuserrole/contactsmodule/create`,
    delete: `/api/v1/platformuserrole/contactsmodule/delete`,
    createBulk: `/api/v1/platformuserrole/contactsmodule/contacts-upload`,
    search: {
      sites: "/api/v1/platformuserrole/contactsmodule/create-sites-search",
      projects: "/api/v1/platformuserrole/contactsmodule/create-projects-search",
      siteUsers: "/api/v1/platformuserrole/contactsmodule/create-site-users-search",
    },
    getContactTypes: "/api/v1/platformuserrole/contactsmodule/get-contact-types",
  },
  catalogueItems: {
    list: "/api/v1/platformuserrole/catalogueitemsmodule/list",
    listCSV: "/api/v1/platformuserrole/catalogueitemsmodule/list-csv",
    view: "/api/v1/platformuserrole/catalogueitemsmodule/view",
    edit: "/api/v1/platformuserrole/catalogueitemsmodule/edit",
    create: "/api/v1/platformuserrole/catalogueitemsmodule/create",
    delete: "/api/v1/platformuserrole/catalogueitemsmodule/delete",
    search: {
      supplierCompanies:
        "/api/v1/platformuserrole/catalogueitemsmodule/create-supplier-company-search",
    },
    createBulk: `/api/v1/platformuserrole/catalogueitemsmodule/catalogue-items-upload`,
  },
  shop: {
    list: "/api/v1/platformuserrole/shopmodule/list",
    view: "/api/v1/platformuserrole/shopmodule/view",
    basket: {
      list: "/api/v1/platformuserrole/shopmodule/basket/list",
      create: "/api/v1/platformuserrole/shopmodule/basket/create",
      update: "/api/v1/platformuserrole/shopmodule/basket/update",
      delete: "/api/v1/platformuserrole/shopmodule/basket/delete",
      checkout: "/api/v1/platformuserrole/shopmodule/basket/checkout",
    },
    splash: "/api/v1/platformuserrole/shopmodule/splash",
  },
  workflowConfiguration: {
    list: "/api/v1/platformuserrole/workflowconfigurationmodule/list",
    listCSV: "/api/v1/platformuserrole/workflowconfigurationmodule/list-csv",
    view: "/api/v1/platformuserrole/workflowconfigurationmodule/view",
    create: "/api/v1/platformuserrole/workflowconfigurationmodule/create",
    edit: "/api/v1/platformuserrole/workflowconfigurationmodule/edit",
    delete: "/api/v1/platformuserrole/workflowconfigurationmodule/delete",
    clone: "/api/v1/platformuserrole/workflowconfigurationmodule/clone",
    builder: "/api/v1/platformuserrole/workflowconfigurationmodule/workflow-builder",
    getTask: "/api/v1/platformuserrole/workflowconfigurationmodule/get-associated-tasks",
    search: {
      programmes: "/api/v1/platformuserrole/workflowconfigurationmodule/create-programmes-search",
      tasks: "/api/v1/platformuserrole/workflowconfigurationmodule/create-tasks-search",
      milestones: "/api/v1/platformuserrole/workflowconfigurationmodule/create-milestones-search",
    },
  },
  taskWorkflowSyncMappings: {
    list: "/api/v1/platformuserrole/taskworkflowsyncmappingsmodule/list",
    view: "/api/v1/platformuserrole/taskworkflowsyncmappingsmodule/view",
    create: "/api/v1/platformuserrole/taskworkflowsyncmappingsmodule/create",
    edit: "/api/v1/platformuserrole/taskworkflowsyncmappingsmodule/edit",
    delete: "/api/v1/platformuserrole/taskworkflowsyncmappingsmodule/delete",
  },
  assetCustomFields: {
    list: "/api/v1/platformuserrole/customfieldsmodule/assets/list",
    view: "/api/v1/platformuserrole/customfieldsmodule/assets/view",
    edit: "/api/v1/platformuserrole/customfieldsmodule/assets/edit",
    create: "/api/v1/platformuserrole/customfieldsmodule/assets/create",
    delete: "/api/v1/platformuserrole/customfieldsmodule/assets/delete",
  },
  catalogueItemsCustomFields: {
    list: "/api/v1/platformuserrole/customfieldsmodule/catalogueitems/list",
    view: "/api/v1/platformuserrole/customfieldsmodule/catalogueitems/view",
    edit: "/api/v1/platformuserrole/customfieldsmodule/catalogueitems/edit",
    create: "/api/v1/platformuserrole/customfieldsmodule/catalogueitems/create",
    delete: "/api/v1/platformuserrole/customfieldsmodule/catalogueitems/delete",
  },
  projectCustomFields: {
    list: "/api/v1/platformuserrole/customfieldsmodule/projects/list",
    view: "/api/v1/platformuserrole/customfieldsmodule/projects/view",
    edit: "/api/v1/platformuserrole/customfieldsmodule/projects/edit",
    create: "/api/v1/platformuserrole/customfieldsmodule/projects/create",
    delete: "/api/v1/platformuserrole/customfieldsmodule/projects/delete",
  },
  siteCustomFields: {
    list: "/api/v1/platformuserrole/customfieldsmodule/sites/list",
    view: "/api/v1/platformuserrole/customfieldsmodule/sites/view",
    edit: "/api/v1/platformuserrole/customfieldsmodule/sites/edit",
    create: "/api/v1/platformuserrole/customfieldsmodule/sites/create",
    delete: "/api/v1/platformuserrole/customfieldsmodule/sites/delete",
  },
  siteCustomTypes: {
    list: "/api/v1/platformuserrole/sitetypesmodule/list",
    view: "/api/v1/platformuserrole/sitetypesmodule/view",
    edit: "/api/v1/platformuserrole/sitetypesmodule/edit",
    create: "/api/v1/platformuserrole/sitetypesmodule/create",
    delete: "/api/v1/platformuserrole/sitetypesmodule/delete",
  },
  assetCustomTypes: {
    list: "/api/v1/platformuserrole/assetstatustypesmodule/list",
    view: "/api/v1/platformuserrole/assetstatustypesmodule/view",
    edit: "/api/v1/platformuserrole/assetstatustypesmodule/edit",
    create: "/api/v1/platformuserrole/assetstatustypesmodule/create",
    delete: "/api/v1/platformuserrole/assetstatustypesmodule/delete",
  },
  assetGroupCustomTypes: {
    list: "/api/v1/platformuserrole/assetgrouptypesmodule/list",
    view: "/api/v1/platformuserrole/assetgrouptypesmodule/view",
    edit: "/api/v1/platformuserrole/assetgrouptypesmodule/edit",
    create: "/api/v1/platformuserrole/assetgrouptypesmodule/create",
    delete: "/api/v1/platformuserrole/assetgrouptypesmodule/delete",
  },
  assetStatusCustomTypes: {
    list: "/api/v1/platformuserrole/assetstatustypesmodule/list",
    view: "/api/v1/platformuserrole/assetstatustypesmodule/view",
    edit: "/api/v1/platformuserrole/assetstatustypesmodule/edit",
    create: "/api/v1/platformuserrole/assetstatustypesmodule/create",
    delete: "/api/v1/platformuserrole/assetstatustypesmodule/delete",
  },
  contactCustomTypes: {
    list: "/api/v1/platformuserrole/contacttypesmodule/list",
    view: "/api/v1/platformuserrole/contacttypesmodule/view",
    edit: "/api/v1/platformuserrole/contacttypesmodule/edit",
    create: "/api/v1/platformuserrole/contacttypesmodule/create",
    delete: "/api/v1/platformuserrole/contacttypesmodule/delete",
  },
  catalogueCustomTypes: {
    list: "/api/v1/platformuserrole/cataloguetypesmodule/list",
    view: "/api/v1/platformuserrole/cataloguetypesmodule/view",
    edit: "/api/v1/platformuserrole/cataloguetypesmodule/edit",
    create: "/api/v1/platformuserrole/cataloguetypesmodule/create",
    delete: "/api/v1/platformuserrole/cataloguetypesmodule/delete",
  },
  clientCompanyCustomTypes: {
    list: "/api/v1/platformuserrole/clientcompanytypesmodule/list",
    view: "/api/v1/platformuserrole/clientcompanytypesmodule/view",
    edit: "/api/v1/platformuserrole/clientcompanytypesmodule/edit",
    create: "/api/v1/platformuserrole/clientcompanytypesmodule/create",
    delete: "/api/v1/platformuserrole/clientcompanytypesmodule/delete",
  },
  companyCustomTypes: {
    list: "/api/v1/platformuserrole/companytypesmodule/list",
    view: "/api/v1/platformuserrole/companytypesmodule/view",
    edit: "/api/v1/platformuserrole/companytypesmodule/edit",
    create: "/api/v1/platformuserrole/companytypesmodule/create",
    delete: "/api/v1/platformuserrole/companytypesmodule/delete",
  },
  contactStatusCustomTypes: {
    list: "/api/v1/platformuserrole/contactstatustypesmodule/list",
    view: "/api/v1/platformuserrole/contactstatustypesmodule/view",
    edit: "/api/v1/platformuserrole/contactstatustypesmodule/edit",
    create: "/api/v1/platformuserrole/contactstatustypesmodule/create",
    delete: "/api/v1/platformuserrole/contactstatustypesmodule/delete",
  },
  dashboardCustomTypes: {
    list: "/api/v1/platformuserrole/dashboardtypesmodule/list",
    view: "/api/v1/platformuserrole/dashboardtypesmodule/view",
    edit: "/api/v1/platformuserrole/dashboardtypesmodule/edit",
    create: "/api/v1/platformuserrole/dashboardtypesmodule/create",
    delete: "/api/v1/platformuserrole/dashboardtypesmodule/delete",
  },
  documentCustomTypes: {
    list: "/api/v1/platformuserrole/documenttypesmodule/list",
    view: "/api/v1/platformuserrole/documenttypesmodule/view",
    edit: "/api/v1/platformuserrole/documenttypesmodule/edit",
    create: "/api/v1/platformuserrole/documenttypesmodule/create",
    delete: "/api/v1/platformuserrole/documenttypesmodule/delete",
  },
  gatewayCustomTypes: {
    list: "/api/v1/platformuserrole/gatewaytypesmodule/list",
    view: "/api/v1/platformuserrole/gatewaytypesmodule/view",
    edit: "/api/v1/platformuserrole/gatewaytypesmodule/edit",
    create: "/api/v1/platformuserrole/gatewaytypesmodule/create",
    delete: "/api/v1/platformuserrole/gatewaytypesmodule/delete",
  },
  platformUserCustomTypes: {
    list: "/api/v1/platformuserrole/platformusertypesmodule/list",
    view: "/api/v1/platformuserrole/platformusertypesmodule/view",
    edit: "/api/v1/platformuserrole/platformusertypesmodule/edit",
    create: "/api/v1/platformuserrole/platformusertypesmodule/create",
    delete: "/api/v1/platformuserrole/platformusertypesmodule/delete",
  },
  principleUserCustomTypes: {
    list: "/api/v1/platformuserrole/principleusertypesmodule/list",
    view: "/api/v1/platformuserrole/principleusertypesmodule/view",
    edit: "/api/v1/platformuserrole/principleusertypesmodule/edit",
    create: "/api/v1/platformuserrole/principleusertypesmodule/create",
    delete: "/api/v1/platformuserrole/principleusertypesmodule/delete",
  },
  programmeStatusCustomTypes: {
    list: "/api/v1/platformuserrole/programmestatustypesmodule/list",
    view: "/api/v1/platformuserrole/programmestatustypesmodule/view",
    edit: "/api/v1/platformuserrole/programmestatustypesmodule/edit",
    create: "/api/v1/platformuserrole/programmestatustypesmodule/create",
    delete: "/api/v1/platformuserrole/programmestatustypesmodule/delete",
  },
  roleCustomTypes: {
    list: "/api/v1/platformuserrole/roletypesmodule/list",
    view: "/api/v1/platformuserrole/roletypesmodule/view",
    edit: "/api/v1/platformuserrole/roletypesmodule/edit",
    create: "/api/v1/platformuserrole/roletypesmodule/create",
    delete: "/api/v1/platformuserrole/roletypesmodule/delete",
  },
  programmeCustomTypes: {
    list: "/api/v1/platformuserrole/programmetypesmodule/list",
    view: "/api/v1/platformuserrole/programmetypesmodule/view",
    edit: "/api/v1/platformuserrole/programmetypesmodule/edit",
    create: "/api/v1/platformuserrole/programmetypesmodule/create",
    delete: "/api/v1/platformuserrole/programmetypesmodule/delete",
  },
  projectCustomTypes: {
    list: "/api/v1/platformuserrole/projecttypesmodule/list",
    view: "/api/v1/platformuserrole/projecttypesmodule/view",
    edit: "/api/v1/platformuserrole/projecttypesmodule/edit",
    create: "api/v1/platformuserrole/projecttypesmodule/create",
    delete: "api/v1/platformuserrole/projecttypesmodule/delete",
  },
  projectStatusCustomTypes: {
    list: "/api/v1/platformuserrole/projectstatustypesmodule/list",
    view: "/api/v1/platformuserrole/projectstatustypesmodule/view",
    edit: "/api/v1/platformuserrole/projectstatustypesmodule/edit",
    create: "/api/v1/platformuserrole/projectstatustypesmodule/create",
    delete: "/api/v1/platformuserrole/projectstatustypesmodule/delete",
  },
  siteStatusCustomTypes: {
    list: "/api/v1/platformuserrole/sitestatustypesmodule/list",
    view: "/api/v1/platformuserrole/sitestatustypesmodule/view",
    edit: "/api/v1/platformuserrole/sitestatustypesmodule/edit",
    create: "/api/v1/platformuserrole/sitestatustypesmodule/create",
    delete: "/api/v1/platformuserrole/sitestatustypesmodule/delete",
  },
  gateways: {
    list: "/api/v1/platformuserrole/gatewaysmodule/list",
    listCSV: "/api/v1/platformuserrole/gatewaysmodule/list-csv",
    view: "/api/v1/platformuserrole/gatewaysmodule/view",
    edit: "/api/v1/platformuserrole/gatewaysmodule/edit",
    create: "/api/v1/platformuserrole/gatewaysmodule/create",
    delete: "/api/v1/platformuserrole/gatewaysmodule/delete",
    gatewaysHeaderMilestoneUpdate:
      "/api/v1/platformuserrole/gatewaysmodule/gateways-header-milestone-update",
    search: {
      project: "/api/v1/platformuserrole/gatewaysmodule/create-projects-search",
      role: "/api/v1/platformuserrole/gatewaysmodule/create-roles-search",
    },
    createMilestoneTask: "/api/v1/platformuserrole/gatewaysmodule/create-task",
    editMilestoneTask: "/api/v1/platformuserrole/gatewaysmodule/edit-task",
    createDataCollection: "/api/v1/platformuserrole/gatewaysmodule/create-task-data-collection",
    editDataCollection: "/api/v1/platformuserrole/gatewaysmodule/edit-task-data-collection",
    gatewayBuilder: "/api/v1/platformuserrole/gatewaysmodule/gateway-builder",
    deleteTask: "/api/v1/platformuserrole/gatewaysmodule/delete-tasks",
    clone: "/api/v1/platformuserrole/gatewaysmodule/clone",
  },
  documents: {
    list: "/api/v1/platformuserrole/documentsmodule/list",
    listCSV: "/api/v1/platformuserrole/documentsmodule/list-csv",
    view: "/api/v1/platformuserrole/documentsmodule/view",
    edit: "/api/v1/platformuserrole/documentsmodule/edit",
    create: "/api/v1/platformuserrole/documentsmodule/create",
    delete: "/api/v1/platformuserrole/documentsmodule/delete",
    cardList: "/api/v1/platformuserrole/documentsmodule/card-list",
    download: "/api/v1/platformuserrole/documentsmodule/download",
    uploadNewVersion: `/api/v1/platformuserrole/documentsmodule/upload`,
    markasfavourite: "/api/v1/platformuserrole/documentsmodule/favourite",
    search: {
      projects: "/api/v1/platformuserrole/documentsmodule/create-associated-projects-search",
      programmes: "/api/v1/platformuserrole/documentsmodule/create-associated-programmes-search",
    },
  },
  dashboards: {
    list: `/api/v1/platformuserrole/dashboardsmodule/list`,
    listCSV: "/api/v1/platformuserrole/dashboardsmodule/list-csv",
    view: `/api/v1/platformuserrole/dashboardsmodule/view`,
    edit: `/api/v1/platformuserrole/dashboardsmodule/edit`,
    create: `/api/v1/platformuserrole/dashboardsmodule/create`,
    delete: `/api/v1/platformuserrole/dashboardsmodule/delete`,
    accessRights: "/api/v1/platformuserrole/dashboardsmodule/edit-access-details",
    listParameters: `/api/v1/platformuserrole/dashboardsmodule/parameters/list`,
    createParameters: `/api/v1/platformuserrole/dashboardsmodule/parameters/create`,
    updateParameters: `/api/v1/platformuserrole/dashboardsmodule/parameters/update`,
    deleteParameters: `/api/v1/platformuserrole/dashboardsmodule/parameters/delete`,
    search: {
      roles: "/api/v1/platformuserrole/dashboardsmodule/create-roles-search",
      siteUsers: "/api/v1/platformuserrole/dashboardsmodule/create-site-users-search",
    },
  },
  programmes: {
    list: "/api/v1/platformuserrole/programmesmodule/list",
    listCSV: "/api/v1/platformuserrole/programmesmodule/list-csv",
    view: "/api/v1/platformuserrole/programmesmodule/view",
    edit: "/api/v1/platformuserrole/programmesmodule/edit",
    create: "/api/v1/platformuserrole/programmesmodule/create",
    delete: "/api/v1/platformuserrole/programmesmodule/delete",
    search: {
      gateways: "/api/v1/platformuserrole/programmesmodule/create-gateways-search",
    },
  },
  projectmanagement: {
    list: "/api/v1/platformuserrole/projectmanagementmodule/list",
    programmeSearch:
      "/api/v1/platformuserrole/projectmanagementmodule/create-parent-programme-search",
    programmesList: "/api/v1/platformuserrole/projectmanagementmodule/programmes",
    listCSV: "/api/v1/platformuserrole/projectmanagementmodule/list-csv",
    overviewSummary: "/api/v1/platformuserrole/projectmanagementmodule/overview",
    overviewGateways: "/api/v1/platformuserrole/projectmanagementmodule/gateways-overview",
    deactivateProject: "/api/v1/platformuserrole/projectmanagementmodule/deactivate",
    delete: "",
    edit: "/api/v1/platformuserrole/projectmanagementmodule/edit",
    listColumns: "/api/v1/platformuserrole/projectmanagementmodule/list-columns",
    listRowData: "/api/v1/platformuserrole/projectmanagementmodule/list-rowdata",
    masterContacts: "/api/v1/platformuserrole/projectmanagementmodule/master-contacts",
    nestedPages: {
      documents: {
        list: "/api/v1/platformuserrole/projectmanagementmodule/documents-list",
        cardList: "/api/v1/platformuserrole/projectmanagementmodule/documents-card-list",
        listCsv: "/api/v1/platformuserrole/projectmanagementmodule/documents-list-csv",
        view: "/api/v1/platformuserrole/projectmanagementmodule/documents-view",
        create: "/api/v1/platformuserrole/projectmanagementmodule/documents-create",
        edit: "/api/v1/platformuserrole/projectmanagementmodule/documents-edit",
        delete: "/api/v1/platformuserrole/projectmanagementmodule/documents-delete",
        download: "/api/v1/platformuserrole/projectmanagementmodule/documents-download",
        upload: "/api/v1/platformuserrole/projectmanagementmodule/documents-upload",
        favourite: "/api/v1/platformuserrole/projectmanagementmodule/documents-favourite",
        search: {
          projects:
            "/api/v1/platformuserrole/projectmanagementmodule/documents-create-associated-projects-search",
          programmes:
            "/api/v1/platformuserrole/projectmanagementmodule/documents-create-associated-programmes-search",
        },
      },
      contacts: {
        list: "/api/v1/platformuserrole/projectmanagementmodule/contacts-list",
        listCsv: "/api/v1/platformuserrole/projectmanagementmodule/contacts-list-csv",
        view: "/api/v1/platformuserrole/projectmanagementmodule/contacts-view",
        create: "/api/v1/platformuserrole/projectmanagementmodule/contacts-create",
        edit: "/api/v1/platformuserrole/projectmanagementmodule/contacts-edit",
        delete: "/api/v1/platformuserrole/projectmanagementmodule/contacts-delete",
        upload: "/api/v1/platformuserrole/projectmanagementmodule/contacts-upload",
        search: {
          siteUsers:
            "/api/v1/platformuserrole/projectmanagementmodule/contacts-create-site-users-search",
        },
      },
      assets: {
        list: "/api/v1/platformuserrole/projectmanagementmodule/assets-list",
        listCsv: "/api/v1/platformuserrole/projectmanagementmodule/assets-list-csv",
        cardList: "/api/v1/platformuserrole/projectmanagementmodule/assets-card-list",
        view: "/api/v1/platformuserrole/projectmanagementmodule/assets-view",
        create: "/api/v1/platformuserrole/projectmanagementmodule/assets-create",
        edit: "/api/v1/platformuserrole/projectmanagementmodule/assets-edit",
        delete: "/api/v1/platformuserrole/projectmanagementmodule/assets-delete",
        upload: "/api/v1/platformuserrole/projectmanagementmodule/assets-upload",
        assetsDateUpdate: "/api/v1/platformuserrole/projectmanagementmodule/assets-dates-update",
        assetsSnaggingUpdate:
          "/api/v1/platformuserrole/projectmanagementmodule/assets-snagging-update",
        updateAssetStatus:
          "/api/v1/platformuserrole/projectmanagementmodule/assets-statuses-update",
        search: {
          supplier:
            "/api/v1/platformuserrole/projectmanagementmodule/assets-create-supplier-company-search",
          assetStatusTypesID:
            "/api/v1/platformuserrole/projectmanagementmodule/assets-create-asset-type-search",
          assetGroup:
            "/api/v1/platformuserrole/projectmanagementmodule/assets-create-asset-group-search",
          catalogueItems:
            "/api/v1/platformuserrole/projectmanagementmodule/assets-create-catalogue-items-search",
        },
      },
      communication: {
        communicationList: "/api/v1/platformuserrole/communicationsmodule/project-list",
        archive: "/api/v1/platformuserrole/communicationsmodule/archive",
        sendMessage: "/api/v1/platformuserrole/communicationsmodule/create",
        searchContacts: "/api/v1/platformuserrole/communicationsmodule/project-contacts-search",
      },
      workflows: {
        list: `/api/v1/platformuserrole/projectmanagementmodule/workflows-list`,
        listCSV: "/api/v1/platformuserrole/projectmanagementmodule/workflows-list-csv",
        delete: `/api/v1/platformuserrole/projectmanagementmodule/workflows-delete`,
        create: `/api/v1/platformuserrole/projectmanagementmodule/workflows-create`,
        search: {
          sites: "/api/v1/platformuserrole/contactsmodule/create-sites-search",
          projects: "/api/v1/platformuserrole/contactsmodule/create-projects-search",
          siteUsers: "/api/v1/platformuserrole/contactsmodule/create-site-users-search",
        },
      },
      surveys: {
        list: "/api/v1/platformuserrole/projectmanagementmodule/surveys-list",
        listCsv: "/api/v1/platformuserrole/projectmanagementmodule/surveys-list-csv",
        delete: "/api/v1/platformuserrole/projectmanagementmodule/surveys-delete",
        view: "/api/v1/platformuserrole/projectmanagementmodule/surveys-view",
        create: "/api/v1/platformuserrole/projectmanagementmodule/surveys-create",
        reassign: "/api/v1/platformuserrole/projectmanagementmodule/surveys-reassign",
        deploy: "/api/v1/platformuserrole/projectmanagementmodule/surveys-deploy",
        refresh: "/api/v1/platformuserrole/projectmanagementmodule/surveys-refresh",
        edit: "/api/v1/platformuserrole/projectmanagementmodule/surveys-edit",
        recall: "/api/v1/platformuserrole/projectmanagementmodule/surveys-recall",
        download: "/api/v1/platformuserrole/projectmanagementmodule/surveys-download",
      },
      histories: {
        list: "/api/v1/platformuserrole/projectmanagementmodule/changelogs-list",
        search: {},
      },
      kpi: {
        kpiData: "/api/v1/platformuserrole/projectmanagementmodule/kpis-get-kpis",
        kpiException: "/api/v1/platformuserrole/projectmanagementmodule/kpis-submit-exception",
      },
    },
    getGateways: "/api/v1/platformuserrole/projectmanagementmodule/gateways-get-gateways",
    getGateway: "/api/v1/platformuserrole/projectmanagementmodule/gateways-get-gateway",
    gatewaysEditTaskData:
      "/api/v1/platformuserrole/projectmanagementmodule/gateways-edit-task-data",
    gatewaysEditNaValue: "/api/v1/platformuserrole/projectmanagementmodule/gateways-edit-na-value",
    search: {
      sites: "/api/v1/platformuserrole/projectmanagementmodule/create-sites-search",
    },
  },
  surveys: {
    list: "/api/v1/platformuserrole/surveysmodule/list",
    listCSV: "/api/v1/platformuserrole/surveysmodule/list-csv",
    delete: "/api/v1/platformuserrole/surveysmodule/delete",
    view: "/api/v1/platformuserrole/surveysmodule/view",
    create: "/api/v1/platformuserrole/surveysmodule/create",
    reassign: "/api/v1/platformuserrole/surveysmodule/reassign",
    deploy: "/api/v1/platformuserrole/surveysmodule/deploy",
    refresh: "/api/v1/platformuserrole/surveysmodule/refresh",
    edit: "/api/v1/platformuserrole/surveysmodule/edit",
    recall: "/api/v1/platformuserrole/surveysmodule/recall",
    download: "/api/v1/platformuserrole/surveysmodule/download",
    search: {
      programmes: "/api/v1/platformuserrole/surveysmodule/create-programmes-search",
      surveyTemplates: "/api/v1/platformuserrole/surveysmodule/create-survey-templates-search",
    },
    createBulk: "/api/v1/platformuserrole/surveysmodule/surveys-upload",
  },
  workflows: {
    list: `/api/v1/platformuserrole/workflowsmodule/list`,
    listCSV: "/api/v1/platformuserrole/workflowsmodule/list-csv",
    view: `/api/v1/platformuserrole/workflowsmodule/view`,
    delete: `/api/v1/platformuserrole/workflowsmodule/delete`,
    create: `/api/v1/platformuserrole/workflowsmodule/create`,
    reasonCodeOptions: "/api/v1/platformuserrole/workflowsmodule/options",
    search: {
      sites: "/api/v1/platformuserrole/contactsmodule/create-sites-search",
      projects: "/api/v1/platformuserrole/contactsmodule/create-projects-search",
      siteUsers: "/api/v1/platformuserrole/contactsmodule/create-site-users-search",
    },
  },
  home: {
    lastViewedProjects: "/api/v1/platformuserrole/homemodule/list-lastviewedprojects",
    workflowactions: "/api/v1/platformuserrole/homemodule/actions-approvals-list",
    reviewAction: "/api/v1/platformuserrole/homemodule/review-action",
    reviewApproval: "/api/v1/platformuserrole/homemodule/review-approval",
    viewWorkflow: "/api/v1/platformuserrole/homemodule/notifications-view",
    viewCommunication: "/api/v1/platformuserrole/homemodule/communications-view",
    listWorkflowNotifications: "/api/v1/platformuserrole/homemodule/notifications-list",
    listDashboard: "/api/v1/platformuserrole/homemodule/list-dashboard",
    listCsv: "/api/v1/platformuserrole/homemodule/actions-approvals-list-csv",
    invoicesEditProjectManager: "/api/v1/platformuserrole/homemodule/update-productmanager",
    invoicesEditApClerk: "/api/v1/platformuserrole/homemodule/update-apclerk",
    invoicesEditFinance: "/api/v1/platformuserrole/homemodule/update-apcoordinator",
  },
  catalogueGroupCustomTypes: {
    list: "/api/v1/platformuserrole/cataloguegroupsmodule/list",
    view: "/api/v1/platformuserrole/cataloguegroupsmodule/view",
    edit: "/api/v1/platformuserrole/cataloguegroupsmodule/edit",
    create: "/api/v1/platformuserrole/cataloguegroupsmodule/create",
    delete: "/api/v1/platformuserrole/cataloguegroupsmodule/delete",
  },
  catalogueSubGroupCustomTypes: {
    list: "/api/v1/platformuserrole/cataloguesubgroupsmodule/list",
    view: "/api/v1/platformuserrole/cataloguesubgroupsmodule/view",
    edit: "/api/v1/platformuserrole/cataloguesubgroupsmodule/edit",
    create: "/api/v1/platformuserrole/cataloguesubgroupsmodule/create",
    delete: "/api/v1/platformuserrole/cataloguesubgroupsmodule/delete",
  },
  catalogueCategoryCustomTypes: {
    list: "/api/v1/platformuserrole/cataloguecategoriesmodule/list",
    view: "/api/v1/platformuserrole/cataloguecategoriesmodule/view",
    edit: "/api/v1/platformuserrole/cataloguecategoriesmodule/edit",
    create: "/api/v1/platformuserrole/cataloguecategoriesmodule/create",
    delete: "/api/v1/platformuserrole/cataloguecategoriesmodule/delete",
  },
  invoices: {
    create: "/api/v1/platformuserrole/invoicesmodule/upload",
    delete: "/api/v1/platformuserrole/invoicesmodule/delete",
    download: "/api/v1/platformuserrole/invoicesmodule/download",
    edit: "/api/v1/platformuserrole/invoicesmodule/update",
    editApClerk: "/api/v1/platformuserrole/invoicesmodule/update-apclerk",
    editFinance: "/api/v1/platformuserrole/invoicesmodule/update-apcoordinator",
    editProjectManager: "/api/v1/platformuserrole/invoicesmodule/update-productmanager",
    list: "/api/v1/platformuserrole/invoicesmodule/list",
    listCSV: "/api/v1/platformuserrole/invoicesmodule/list-csv",
    update_document: "/api/v1/platformuserrole/invoicesmodule/update-document",
    upload: "/api/v1/platformuserrole/invoicesmodule/upload",
    view: "/api/v1/platformuserrole/invoicesmodule/view",
    search: {
      suppliers: "/api/v1/platformuserrole/invoicesmodule/suppliers-search",
      programs: "/api/v1/platformuserrole/invoicesmodule/programs-search",
      projectManagers: "/api/v1/platformuserrole/invoicesmodule/project-managers-search",
      assignedUsers: "/api/v1/platformuserrole/invoicesmodule/assigned-users-search",
    },
  },
  inboundLog: {
    list: "/api/v1/platformuserrole/GreenDoorModule/Api/list",
    csv: "/api/v1/platformuserrole/GreenDoorModule/Api/list-csv",
    view: "/api/v1/platformuserrole/GreenDoorModule/Api/view",
  },
  outboundLog: {
    list: "/api/v1/platformuserrole/GreenDoorModule/Push/list",
    csv: "/api/v1/platformuserrole/GreenDoorModule/Push/list-csv",
    view: "/api/v1/platformuserrole/GreenDoorModule/Push/view",
  },
  surveyTemplates: {
    list: "/api/v1/platformuserrole/surveytemplatesmodule/list",
    listcsv: "/api/v1/platformuserrole/surveytemplatesmodule/list-csv",
    view: "/api/v1/platformuserrole/surveytemplatesmodule/view",
    edit: "/api/v1/platformuserrole/surveytemplatesmodule/edit",
  },
  surveyors: {
    list: "/api/v1/platformuserrole/surveyorsmodule/list",
    listcsv: "/api/v1/platformuserrole/surveyorsmodule/list-csv",
    view: "/api/v1/platformuserrole/surveyorsmodule/view",
    edit: "/api/v1/platformuserrole/surveyorsmodule/edit",
  },
  emailTemplates: {
    list: "/api/v1/platformuserrole/emailtemplatesmodule/list",
    view: "/api/v1/platformuserrole/emailtemplatesmodule/view",
    edit: "/api/v1/platformuserrole/emailtemplatesmodule/edit",
  },
  histories: {
    list: `/api/v1/platformuserrole/rolesmodule/list`,
    search: {},
  },
  kpis: {
    list: `/api/v1/platformuserrole/kpismodule/list`,
    listcsv: `/api/v1/platformuserrole/kpismodule/list-csv`,
    edit: `/api/v1/platformuserrole/kpismodule/edit`,
    create: `/api/v1/platformuserrole/kpismodule/create`,
    delete: `/api/v1/platformuserrole/kpismodule/delete`,
  },
  communicationCustomTypes: {
    list: "/api/v1/platformuserrole/communicationtypesmodule/list",
    edit: "/api/v1/platformuserrole/communicationtypesmodule/edit",
    create: "/api/v1/platformuserrole/communicationtypesmodule/create",
    delete: "/api/v1/platformuserrole/communicationtypesmodule/delete",
  },
  communicationCategoriesCustomTypes: {
    list: "/api/v1/platformuserrole/communicationcategoriesmodule/list",
    edit: "/api/v1/platformuserrole/communicationcategoriesmodule/edit",
    create: "/api/v1/platformuserrole/communicationcategoriesmodule/create",
    delete: "/api/v1/platformuserrole/communicationcategoriesmodule/delete",
  },
  communications: {
    edit: "/api/v1/platformuserrole/communicationsmodule/edit",
    markread: "/api/v1/platformuserrole/communicationsmodule/mark-read",
  },
  supplierFeedback: {
    create: "/api/v1/platformuserrole/supplierfeedbackmodule/create",
    edit: "/api/v1/platformuserrole/supplierfeedbackmodule/edit",
    delete: "/api/v1/platformuserrole/supplierfeedbackmodule/delete",
    list: "/api/v1/platformuserrole/supplierfeedbackmodule/list",
  },
  ncrCategory: {
    list: "/api/v1/platformuserrole/ncrcategorymodule/list",
    create: "/api/v1/platformuserrole/ncrcategorymodule/create",
    edit: "/api/v1/platformuserrole/ncrcategorymodule/edit",
    delete: "/api/v1/platformuserrole/ncrcategorymodule/delete",
  },
  countries: {
    list: "/api/v1/platformuserrole/countriesmodule/list",
    create: "/api/v1/platformuserrole/countriesmodule/create",
    edit: "/api/v1/platformuserrole/countriesmodule/edit",
    delete: "/api/v1/platformuserrole/countriesmodule/delete",
  },
};
export const PARENT_ID_KEY = "parent_id_key";
export const FILTER_KEY = "filter";
export const SEARCHSTRING = "searchstring";
export const PAGE_SIZE = "page_size";
export const ACTION_KEY = "action";
export const ACTION_SELECTED_ID_KEY = "actionSelectedId";
export const RELATED_FORM_DESTINATION_MODULE_NAME = "relatedFormDestinationModuleName";

export const LIST_PARAM_NAME_KEY = "listParamName";
export const LIST_PARAM_VALUE_KEY = "listParamValue";

export enum APP_ROUTES {
  "home" = "/",
  "homedashboard" = "/home",
  "redirect" = "/redirect",
  "workflowNotifications" = "/workflownotifications",
  "platformUsers" = "/platformusers",
  "principleUsers" = "/principleusers",
  "staticContents" = "/staticcontent",
  "signIn" = "/sign-in",
  "signUp" = "/sign-up",
  "authRedirect" = "/signin/callback",
  "forgotPassword" = "/forgotten-password",
  "resetPassword" = "/reset-password",
  "accountVerification" = "/account-verification",
  "account" = "/account",
  "settings" = "/settings",
  "companies" = "/companies",
  "assets" = "assets",
  "sites" = "/sites",
  "projects" = "/projects",
  "roles" = "/roles",
  "contacts" = "/contacts",
  "documents" = "/documents",
  "snaggingassets" = "/snaggingassets",
  "catalogueitems" = "/catalogueitems",
  "cataloguesitems" = "/catalogueitems",
  "clientCompanies" = "/clientcompanies",
  "users" = "/users",
  "sitecustomfields" = "/sitescustomfields",
  "sitecustomtypes" = "/sitetypes",
  "projectcustomfields" = "/projectcustomfields",
  "assetcustomfields" = "/assetcustomfields",
  "catalogueitemcustomfields" = "/catalogueitemcustomfields",
  "programmes" = "/programmes",
  "projectcustomtypes" = "/projecttypes",
  "projectstatuscustomtypes" = "/projectstatustypes",
  "sitestatuscustomtypes" = "/sitestatustypes",
  "contactcustomtypes" = "/contacttypes",
  "cataloguecustomtypes" = "/cataloguetypes",
  "clientcompanycustomtypes" = "/clientcompanytypes",
  "companycustomtypes" = "/companytypes",
  "contactstatuscustomtypes" = "/contactstatustypes",
  "dashboardcustomtypes" = "/dashboardtypes",
  "documentcustomtypes" = "/documenttypes",
  "gatewaycustomtypes" = "/gatewaytypes",
  "assetcustomtypes" = "/assetstatustypes",
  "assetgroupcustomtypes" = "/assetgrouptypes",
  "assetstatuscustomtypes" = "/assetstatustypes",
  "platformusercustomtypes" = "/platformusertypes",
  "principleusercustomtypes" = "/principleusertypes",
  "programmestatuscustomtypes" = "/programmestatustypes",
  "programmecustomtypes" = "/programmetypes",
  "rolecustomtypes" = "/roletypes",
  "gateways" = "/gateways",
  "workflowconfiguration" = "/workflowconfiguration",
  "taskworkflowsyncmappings" = "/taskworkflowsyncmappings",
  "dashboards" = "/dashboards",
  "currencies" = "/currencies",
  "invoicecategorytypes" = "/invoicecategorytypes",
  "paymentoptiontypes" = "/paymentoptiontypes",
  "exchangerates" = "/exchangerates",
  "projectmanagement" = "/projectmanagement",
  "userpools" = "/userpools",
  "holidays" = "/holidays",
  "surveys" = "/surveys",
  "reasoncodes" = "/reasoncodes",
  "workflows" = "/workflows",
  "cataloguegroups" = "/cataloguegroups",
  "cataloguesubgroups" = "/cataloguesubgroups",
  "cataloguecategories" = "/cataloguecategories",
  "invoices" = "/invoices",
  "greendoorpush" = "/greendoorpush",
  "greendoorapi" = "/greendoorapi",
  "surveytemplates" = "/surveytemplates",
  "surveyors" = "/surveyors",
  "emailtemplates" = "/emailtemplates",
  "kpis" = "/kpis",
  "communicationcustomtypes" = "/communicationtypes",
  "communicationcategories" = "/communicationcategories",
  "snaggingcategories" = "/snaggingcategories",
  "shop" = "/shop",
  "supplierfeedback" = "/supplierfeedback",
  "ncrcategory" = "/ncrcategory",
  "countries" = "/countries",
}

/**
 * Maps parent form field names to corresponding child form field names.
 * Used when creating nested records to determine which field in the child form
 * should be pre-populated with the parent record's ID.
 *
 * @example
 * Parent: Sites form has field "projectsID" (array of project IDs)
 * Child: Projects form has field "sitesId" (parent site reference)
 * Mapping: { projectsID: "sitesId" }
 *
 * When creating a Project from Sites:
 * 1. User clicks "Add new project" in Sites form field "projectsID"
 * 2. System looks up PARENT_CHILD_FIELD_MAPPING["projectsID"] → "sitesId"
 * 3. Redux stores: parentFieldNameInChild = "sitesId"
 * 4. Project.tsx receives context and sends: GET /projectsmodule/create?sitesId=1000
 * 5. Project form pre-populates: sitesId field with value [1000]
 */
export const PARENT_CHILD_FIELD_MAPPING: Record<string, string> = {
  projectsID: "sitesId",
  contactsID: "sitesID",
  surveysID: "sitesId",
};
